import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursAbcProblem() {
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-953">
      <div className="max-w-4xl mx-auto px-6" data-id="element-954">
        <SectionHeading title="Simți că muncești mult, dar nu evoluezi financiar?" data-id="element-955" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 shadow-sm border border-brand-text/5 mb-12" data-id="element-956">
          <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed" data-id="element-957">
            <p className="font-bold text-xl text-brand-text" data-id="element-958">
              Muncești, te implici, faci tot ce poți. Dar la finalul lunii,
              situația financiară arată la fel.
            </p>
            <p data-id="element-959">
              Te compari cu alții care par să avanseze ușor și te întrebi ce
              greșești. Poate ai gânduri pe care le repeți fără să îți dai
              seama: "nu pot", "nu merit", "e greu", "nu e suficient." Poate
              nici nu știi exact ce vrei cu adevărat, doar că viața ta ar putea
              fi mai mult decât e acum.
            </p>
            <p data-id="element-960">
              Și cu fiecare lună în care nu faci nimic diferit, tiparele se
              adâncesc. Frustrarea crește, încrederea scade și sentimentul că
              rămâi în urmă devine tot mai greu de ignorat. Nu e vorba că nu
              ești capabilă. E vorba că nimeni nu ți-a arătat cum funcționează
              prosperitatea cu adevărat.
            </p>

            <div className="mt-8 p-6 bg-brand-gold/5 border-l-4 border-brand-gold rounded-r-xl" data-id="element-961">
              <p className="font-medium text-brand-text italic" data-id="element-962">
                Cursul ABC-ul Prosperității te ghidează pas cu pas să descoperi
                sensul adevăratei bogății, să identifici gândurile și credințele
                care te țin pe loc, să le eliberezi și să le înlocuiești cu
                afirmații care lucrează pentru tine. Vei învăța să îți creezi
                propria hartă a comorilor, un instrument practic care îți
                clarifică direcția și te ghidează către cea mai bună versiune a
                vieții tale.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-963">
          <CTAButton data-id="element-964" />
        </motion.div>
      </div>
    </section>;
}